import { CircularProgress } from "@mui/material";
import { Navigate } from "react-router-dom";
import { getVisibleMenu } from "../../components/DashboardSidebar/menuItems";
import usePermission from "../../hooks/usePermission";
import NoAccess from "../NoAccess/NoAccess";

// /dashboard opens the first page the role may use (the dashboard for most roles)
const HomeRedirect = () => {
  const { loading, can } = usePermission();

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", padding: 48 }}>
        <CircularProgress size={28} />
      </div>
    );
  }

  const first = getVisibleMenu(can)
    .flatMap((item) => (item.children ? item.children : [item]))
    .find((entry) => entry.path);

  return first ? <Navigate to={first.path} replace /> : <NoAccess />;
};

export default HomeRedirect;
